export const Footer = () => {
  return (
    <div className="absolute bottom-0 flex w-full flex-row items-center justify-end py-5">
      <h3 className="mr-8 text-base underline">プライバシーポリシー</h3>
      <h3 className="mr-8 text-base underline">利用規約</h3>
      <h3 className="mr-8 text-base underline">© PLANET LLC.</h3>
    </div>
  );
};
